import { Box, Typography } from '@mui/material';
import zeplinColor from 'theme/Color';

import CustomDeleteModal from 'components/shared/CustomDeleteModal/CustomDeleteModal';
import CustomPopOver from 'components/shared/CustomPopOver/CustomPopOver';
import { CompleteOperationType, StartOperationType } from 'model/alerts.model';
import { MouseEvent, useReducer } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { modalReducer } from 'reducers/modalReducer';
import RoutePaths from 'routes/RoutePaths';
import { DealsService } from 'service/deals.service';
import { actions } from './data';
import { muiStyles } from './muiStyles';
import { AnchorType } from './types';
import { useActionsHandlers } from './useActionsHandlers';

const ActionsMenu = ({
  anchor,
  onClose,
  startOperation,
  completeOperation,
}: {
  onClose: () => void;
  isOpen?: boolean;
  anchor: AnchorType;
  startOperation: StartOperationType;
  completeOperation: CompleteOperationType;
}) => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [modalState, dispatch] = useReducer(modalReducer, {
    delete: false,
  });

  const actionsHandlersMap = useActionsHandlers(dispatch, completeOperation);

  const handleDeleteDeal = async () => {
    try {
      if (id) {
        startOperation('delete', 'Deleting Deal');
        await DealsService.deleteDeal(id);
        navigate(RoutePaths.Deals);
        completeOperation('delete', 'Deal Deleted');
      }
    } catch (error) {
      completeOperation('delete', `Unable to delete deal ${error}`, true);
    }
  };

  return (
    <>
      <CustomPopOver
        onClick={(e: MouseEvent<SVGSVGElement>) => e.stopPropagation()}
        setAnchorEl={onClose}
        anchorEl={anchor}
        id={'simple-popover'}
        sx={muiStyles.root}
      >
        <Box sx={muiStyles.actions}>
          {actions.map(({ id, label, Icon }) => (
            <Box
              sx={muiStyles.action}
              key={id}
              component={'button'}
              onClick={actionsHandlersMap[id]}
            >
              <Icon />
              <Typography
                variant='responsiveBody3'
                color={label === 'Delete' ? zeplinColor.Error : zeplinColor.BasicBlack}
              >
                {label}
              </Typography>
            </Box>
          ))}
        </Box>
      </CustomPopOver>

      <CustomDeleteModal
        isModalOpen={modalState.delete}
        modalDispatch={dispatch}
        onDelete={handleDeleteDeal}
        title={''}
      />
    </>
  );
};

export default ActionsMenu;
